export const NativeMessages = {
  ON_INIT: 'oninit',
  SET_CREDENTIALS: 'setcredentials',
  NEEDS_CREDENTIALS: 'needscredentials',
  SET_EXPERIMENTS: 'setexperiments',
  SET_TITLE: 'settitle',
  TOGGLE_MAP: 'togglemap',
  SET_COORDINATES: 'setcoordinates',
  SET_IMF_CONTENT: 'setimfcontent',
  IMF_READY: 'imfready',
  NAVIGATE: 'navigate',
  NATIVE_NAVIGATE: 'native-navigate',
  OPEN_URL: 'openurl',
  ANALYTICS_PAGEVIEW: 'analyticspageview',
  ANALYTICS_ACTION: 'analyticsaction',
  ANALYTICS_NONINTERACTION: 'analyticsnoninteraction',
  CLICKSTREAM_EXPERIMENT: 'clickstreamexperimentevent',
  CLICKSTREAM_IMPRESSION_CLICKED: 'clickstreamimpressionclicked',
  CLICKSTREAM_MODULE_VISIBLE: 'clickstreammodulevisible',
  NAVIGATE_BACK: 'navigateback',
  GO_TO_ROOT: 'pop-to-root',
  ADD_DISMISS: 'add-dismiss',
  TRIGGER_NOTIFICATION: 'trigger-notification',
  BRAZE_CUSTOM_EVENT: 'brazecustomevent',
  SUBSCRIPTION_PURCHASE_SUCCESS: 'standalonesubscriptionpurchasesuccess',
  SET_TOP_RIGHT_BUTTON: 'set-top-right-button',
  TOP_RIGHT_BUTTON_CLICKED: 'top-right-button-clicked',
  RESUME_HYBRID: 'resume-hybrid',
  SUBSCRIPTION_CANCELATION: 'standalonesubscriptioncancel',
  SUBSCRIPTION_UPSELL_ACCEPTED: 'acceptedcancellationupsell',
  SUBSCRIPTION_ACCEPT_GIVEAWAY_SUCCESS: 'subscriptionacceptgiveawaysuccess',
  SUBSCRIPTION_PAYMENT_UPDATED: 'subscriptionpaymentupdated',
  PARTNERSHIP_LINKAGE_SUCCESS: 'partnershiplinkagesuccess',
  LOGOUT: 'logout',
};

export const NavigationId = {
  NATIVE: 'NATIVE',
  URL: 'URL',
};

export const NativeNavigationId = {
  RESTAURANT: 'RESTAURANT',
  SEARCH: 'SEARCH',
  HOME: 'HOME',
  SUBSCRIPTION_CHECKOUT: 'SUBSCRIPTION_CHECKOUT',
  URL: 'URL',
};

export const NavigationType = {
  PUSH: 'PUSH',
  POP: 'POP',
  PRESENT: 'PRESENT',
  DISMISS: 'DISMISS',
};

// Payloads types associated with each NativeMessage
export interface BrazeCustomEventPayload {
  name: string;
  properties: { [key: string]: string };
}

export interface TriggerNotificationPayload {
  primaryText: string;
  secondaryText: string;
}

export interface ExperimentOverride {
  name: string;
  value: unknown;
}

export interface ExperimentOverridePayload {
  experiments?: ExperimentOverride[];
}
